const utilities = () => {
    document.addEventListener('DOMContentLoaded', function () {
        gdpr();
        pricingTabs();
    });
}

const pricingTabs = () => {
    document.querySelectorAll('.js-pricing-section').forEach(section => {
        const tabs = section.querySelectorAll('.js-tabs [data-tab]');
        const contents = section.querySelectorAll('.js-tab-content');

        if (!tabs.length || !contents.length) return;

        function setActiveTab(tabName) {
            tabs.forEach(tab => {
                tab.classList.toggle('active', tab.dataset.tab === tabName);
            });

            contents.forEach(content => {
                const isActive = content.dataset.tabContent === tabName;
                content.classList.toggle('hidden', !isActive);
                content.classList.toggle('table', isActive);
            });
        }

        // Init: first tab active
        setActiveTab(tabs[0].dataset.tab);

        // Add click listeners
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                setActiveTab(tab.dataset.tab);
            });
        });
    });
};

const gdpr = () => {
    document.querySelectorAll('.gdpr-terms .wpcf7-list-item input').forEach(function (input) {
        input.addEventListener('click', function (e) {
            e.preventDefault();

            let label = this.parentNode;

            if (label.classList.contains('checked')) {
                this.checked = false;
                label.classList.remove('checked');
            } else {
                this.checked = true;
                label.classList.add('checked');
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", () => {
    const menuItems = document.querySelectorAll(".mobile-menu .menu-item-has-children");

    menuItems.forEach(item => {
        // Create toggle span
        const toggle = document.createElement("span");
        toggle.className = "nav-toggle";
        toggle.innerHTML = `<i class="fa-light fa-chevron-down"></i>`;

        const link = item.querySelector("a");
        link.parentNode.insertBefore(toggle, link.nextSibling);

        const submenu = item.querySelector(".sub-menu");

        toggle.addEventListener("click", () => {
            submenu.classList.toggle("submenu-open");
            toggle.classList.toggle("active");
        });
    });
});



utilities();